import { render, staticRenderFns } from "./RecentGrouped.vue?vue&type=template&id=70d64c87&"
import script from "./RecentGrouped.vue?vue&type=script&lang=js&"
export * from "./RecentGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RecentGrouped.vue"
export default component.exports